interface AcquireTokenAuthErrorOptions {
  readonly errorCode: string;
  readonly errorMessage?: string;
  readonly subError?: string;
}

export class SsoSilentError extends Error {
  public errorCode: string;
  public errorMessage: string;
  public name: string;
  public subError?: string;

  constructor({ errorCode, errorMessage = 'SsoSilentError', subError }: AcquireTokenAuthErrorOptions) {
    super(errorMessage);

    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
    this.name = 'SsoSilentError';
    this.subError = subError;

    Object.setPrototypeOf(this, SsoSilentError.prototype);
  }
}
